'use client';
import { useContext, useEffect, useState } from 'react';
import Button from '@/components/Button';

import { confirmRegisterByEmail, confirmRegisterBySms, confirmRegisterBySmsCode } from '@/services/register';

import useNavigate from '@/hooks/useNavigate';
import { BootstrapContext, ToastContext } from '@/pagesComponents/Layout';
import Errors from '@/services/errors';

const ConfirmAccount = ({
  account,
  confirmByEmail = confirmRegisterByEmail,
  confirmBySMS = confirmRegisterBySms,
  sendSMSCode = confirmRegisterBySmsCode,
  resetState = [false, () => {}],
}) => {
  const navigate = useNavigate();
  const bootstrap = useContext(BootstrapContext);
  const [displayStatus, setStatus] = useState('confirm');
  const [emailSentContents, setEmailSentContents] = useState({});
  const updateToast = useContext(ToastContext);
  const [reset, setReset] = resetState;

  useEffect(() => {
    if (reset) {
      setStatus('confirm');
      setEmailSentContents({});
      console.log('reset', reset);
    }
  }, [reset]);

  const confirmByEmailMethod = confirmByEmail;
  const confirmBySMSMethod = confirmBySMS;
  const receivedCorrectCode = (data) => {
    updateToast({
      message: data.info,
      type: 'success',
    });
    setTimeout(() => {
      if (typeof window !== 'undefined') {
        const toast = document.getElementById('default-toast');
        const toastInstance = bootstrap.Toast.getOrCreateInstance(toast);
        toastInstance.show();

        clearModals();
      }
    }, 100);
  };
  const sendSMSCodeMethod = sendSMSCode ?? (() => {});

  const clearModals = () => {
    if (typeof window !== 'undefined') {
      const modals = document.getElementsByClassName('modal');
      for (const modal of modals) {
        const modalInstance = bootstrap.Modal.getInstance(modal);
        modalInstance?.hide();
      }
    }
  };

  const redirectToHome = (timeout = 10000) => {
    setTimeout(() => {
      clearModals();
      const noRedirectUrls = ['reset-password'];

      if (!noRedirectUrls.some(x => location.href.includes(x))) {
        location.href = '/';
        setTimeout(() => {
          location.reload();
        }, 222);
      }
    }, timeout);
  };
  const handleConfirmEmail = async (account, event) => {
    try {
      event.target.attributes.disabled = true;
      event.target.classList.add('disabled');
      const response = await confirmByEmailMethod(account.email);

      if (response instanceof Error) {
        Errors.handleError(response, updateToast);
        event.target.attributes.disabled = false;
        event.target.classList.remove('disabled');
      } else {
        const { data } = response;
        setEmailSentContents(data);
        setStatus('email');

        redirectToHome();
        event.target.classList.remove('disabled');
      }
    } catch (e) {
      Errors.handleError(e, updateToast);
      event.target.attributes.disabled = false;
      event.target.classList.remove('disabled');
    }
  };
  const handleConfirmPhone = async (account, event) => {
    try {
      event.target.attributes.disabled = true;
      const response = await confirmBySMSMethod(account.email);
      if (response === 'OK') {
        setStatus('phone');
        return;
      } else {
        event.target.attributes.disabled = false;
        Errors.handleError(response, updateToast);
      }
    } catch (e) {
      Errors.handleError(e, updateToast);
      event.target.attributes.disabled = false;
    }
  };
  const handleSendCellCode = async (event) => {
    event.preventDefault();
    // deactivate submit button
    event.target.querySelector('[type=submit]').disabled = true;
    const form = event.target;
    const data = new FormData(form);
    const code = data.get('cellRequest');
    try {
      const response = await confirmRegisterBySmsCode(account.email, code);
      if (response instanceof Error) {
        Errors.handleError(response, updateToast);
        event.target.querySelector('[type=submit]').disabled = false;
        return;
      } else {
        const data = response;
        setStatus('false');
        sendSMSCodeMethod(data);
        receivedCorrectCode(data);
        redirectToHome(3456);
      }
    } catch (e) {
      Errors.handleError(e, updateToast);
      event.target.querySelector('[type=submit]').disabled = false;
    }
  };

  return (
    <>
      {displayStatus !== 'email' && (
        <>
          <div className="border-bottom border-dark pb-3">
            <h4 className={'text-center'}>
              Confirmer votre compte par courriel.
              <br/>
              Un courriel vous sera transmis afin de valider votre compte.
            </h4>
            <div className="d-flex justify-content-center">
              <Button className="btn btn-primary" onClick={(e) => handleConfirmEmail(account, e)}>
                Confirmer par Courriel
              </Button>
            </div>
          </div>
          <div className="pt-3">
            {displayStatus !== 'phone' ? (
              <>
                <h4 className={'text-center'}>
                  Confirmer votre compte par cellulaire.
                  <br/>
                  Un code vous sera transmis par message texte.
                </h4>
                <div className="d-flex justify-content-center">
                  <Button
                    id="confirmBySmsButton"
                    className="btn btn-primary"
                    onClick={(e) => handleConfirmPhone(account, e)}
                  >
                    Confirmer par Cellulaire
                  </Button>
                </div>
              </>
            ) : (
              <>
                <h4 className={'text-center'}>
                  Confirmer votre compte par cellulaire.
                  <br/>
                  Rentrez le code qui vous a été transmis par message texte.
                </h4>
                <form
                  id={'cellCodeForm'}
                  className={'form-group d-flex'}
                  onSubmit={(e) => handleSendCellCode(e)}
                >
                  <input id="code" className="form-control me-2" type="number" name="cellRequest"/>
                  <Button type="submit" className={'btn btn-primary'}>
                    Envoyer
                  </Button>
                </form>
              </>
            )}
          </div>
        </>
      )}
      {displayStatus === 'email' && (
        <>
          <h4 className="text-center">{emailSentContents.title}</h4>
          <p className="text-center" dangerouslySetInnerHTML={{ __html: emailSentContents.message }}/>
        </>
      )}
    </>
  );
};
export default ConfirmAccount;
